import { useEffect, useState } from 'react';
import styles from './list.module.css';
import axios from 'axios';
import { useForm, Controller } from "react-hook-form";
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { authData } from '../../../components/GetAuth';
import dayjs from 'dayjs';

export default function AssignPopup({ selectedId, setLoading, modalClose, setAllData, setSnackbarType, setSnackbarOpen, setSnackbarMessage }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [driverList, setDriverList] = useState([]);

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: 'onChange'
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + 'v1/p-driver-dd-list', {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setDriverList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const onSubmitLocal = (data) => {
    modalClose(false);
    setLoading(true);

    data = { ...data, bookingIds: [selectedId] }

    axios.post(process.env.REACT_APP_API_URL + 'v1/reassign-bookings', data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setLoading(false);
        setSnackbarType('success');
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);

        setAllData(prev => {
          return prev.map(i => {
            if (i?.id === selectedId)
              return { ...i, driver: { ...i?.driver, name: response.data.driver, assigned_date: dayjs().format('YYYY-MM-DD') } };
            return i;
          });
        })
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  const unAssign = () => {
    modalClose(false);
    setLoading(true);

    let data = { bookingIds: [selectedId] }

    axios.post(process.env.REACT_APP_API_URL + 'v1/unassign-bookings', data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        setLoading(false);
        setSnackbarType('success');
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);

        setAllData(prev => {
          return prev.filter(i => i?.id !== selectedId);
        })
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<div className={`${styles.FullDiv}`}>
    <form onSubmit={handleSubmit(onSubmitLocal)}>
      <div className={`${styles.FormGroupFull}`}>
        <div className={`FormHalfGroup`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Select Driver*</InputLabel>
            <Controller
              control={control}
              {...register('driver_id', { required: 'Please select driver' })}
              render={({ field }) => (<Select
                {...field}
                label="Select Driver*"
              >
                {driverList?.map(i => {
                  return <MenuItem key={i?.id} value={i?.id}>{i?.name}</MenuItem>
                })}
              </Select>)}
            />
          </FormControl>
          {errors.driver_id && (<span className={`ErrorM`}>{errors?.driver_id?.message}</span>)}
        </div>
      </div>
      <div className={`FormButtonArea`}>
        <Button className={`CancelBU`} onClick={(e) => unAssign()}>Unassign</Button>
        <Button className={`SubmitBU`} type="submit">Re-assign</Button>
      </div>
    </form>
  </div>)
}